/* V20 — shop client-side filtering (models + colors). Plain JS. */
( function () {
	'use strict';

	var grid = document.getElementById( 'product-grid' );
	if ( ! grid ) {
		return;
	}

	var cards   = grid.querySelectorAll( '.model-card' );
	var models  = document.querySelectorAll( '.filter-model' );
	var colors  = document.querySelectorAll( '.filter-color' );
	var allBox  = document.getElementById( 'model-all' );

	function apply() {
		// "Alle Fatbikes" overrides the model filter: show every model.
		var allOn = allBox && allBox.checked;

		var selModels = [];
		Array.prototype.forEach.call( models, function ( m ) {
			if ( m.checked && m.value !== 'all' ) {
				selModels.push( m.value );
			}
		} );

		var selColors = [];
		Array.prototype.forEach.call( colors, function ( c ) {
			if ( c.classList.contains( 'active' ) ) {
				selColors.push( c.getAttribute( 'data-value' ) );
			}
		} );

		Array.prototype.forEach.call( cards, function ( card ) {
			var okModel = allOn || ! selModels.length || selModels.indexOf( card.getAttribute( 'data-model' ) ) > -1;
			var okColor = ! selColors.length || selColors.indexOf( card.getAttribute( 'data-color' ) ) > -1;
			card.style.display = ( okModel && okColor ) ? '' : 'none';
		} );
	}

	Array.prototype.forEach.call( colors, function ( c ) {
		c.addEventListener( 'click', function () {
			c.classList.toggle( 'active' );
			apply();
		} );
	} );

	Array.prototype.forEach.call( models, function ( m ) {
		m.addEventListener( 'change', function () {
			if ( m.value === 'all' ) {
				// Checking "Alle Fatbikes" clears the specific model boxes.
				if ( m.checked ) {
					Array.prototype.forEach.call( models, function ( o ) {
						if ( o !== m ) {
							o.checked = false;
						}
					} );
				}
			} else if ( m.checked && allBox ) {
				// Picking a specific model turns "Alle Fatbikes" off.
				allBox.checked = false;
			}
			apply();
		} );
	} );

	// Apply on load so the pre-checked Modellen box (set by the /shop/<model>
	// category page) filters the grid immediately.
	apply();
}() );
